export default __webpack_public_path__ + "static/media/Others_Juggler.5c63cb15.svg";